import type {
  CreateExclusionGroupEntityFe,
  ExclusionGroupEntityDto,
  ExperienceDto,
  ExperienceListDto,
  ExperienceStatus,
} from "@intelligems/ig-types";

import { sortBy } from "./common";
import { groupRounder } from "./groupRounder";

export const getTestStatus = (
  entityId: string | undefined,
  allExperiences: Pick<ExperienceDto, "status" | "id">[]
): ExperienceStatus => {
  if (!entityId) {
    return "pending";
  } else {
    const foundTest = allExperiences.find(
      (experiment) => experiment.id === entityId
    );
    if (foundTest) {
      return foundTest.status ?? "pending";
    } else {
      return "pending";
    }
  }
};

export const ensureExclusionGroupEntityOrder = <
  T extends ExclusionGroupEntityDto | CreateExclusionGroupEntityFe,
>(
  exclusionGroupEntities: T[]
) => {
  const sortedEntities = sortBy(exclusionGroupEntities, "order");

  const updatedExclusionGroupEntities: (
    | CreateExclusionGroupEntityFe
    | ExclusionGroupEntityDto
  )[] = [];

  sortedEntities.forEach(
    (entity: CreateExclusionGroupEntityFe | ExclusionGroupEntityDto, index) => {
      updatedExclusionGroupEntities.push({ ...entity, order: index });
    }
  );
  return updatedExclusionGroupEntities;
};

export const innerEnsureExclusionGroupEntityPercentage = (
  filteredExclusionGroupEntities:
    | ExclusionGroupEntityDto[]
    | CreateExclusionGroupEntityFe[],
  allExclusionGroupEntities:
    | ExclusionGroupEntityDto[]
    | CreateExclusionGroupEntityFe[]
) => {
  const filteredEntityIds = filteredExclusionGroupEntities.map(
    (entity: ExclusionGroupEntityDto | CreateExclusionGroupEntityFe) =>
      entity.experienceId
  );

  return ensureExclusionGroupEntityOrder(
    groupRounder(
      allExclusionGroupEntities.map(
        (entity: ExclusionGroupEntityDto | CreateExclusionGroupEntityFe) => ({
          ...entity,
          percentage: !filteredEntityIds.includes(entity.experienceId)
            ? 0
            : 100 / filteredExclusionGroupEntities.length,
        })
      )
    )
  );
};

export const ensureExclusionGroupEntityPercentage = (
  exclusionGroupEntities:
    | ExclusionGroupEntityDto[]
    | CreateExclusionGroupEntityFe[],
  experiencesList: ExperienceListDto[]
) => {
  const filteredEntities = exclusionGroupEntities.filter(
    (entity) => getTestStatus(entity?.experienceId, experiencesList) !== "ended"
  );

  return innerEnsureExclusionGroupEntityPercentage(
    filteredEntities,
    exclusionGroupEntities
  );
};
